import { Component } from "solid-js";
import { publishFinalReviewDoneClick } from "@/services/analytics.service";

interface OrderConfirmationModalProps {
  onClose: () => void;
}

export const OrderConfirmationModal: Component<OrderConfirmationModalProps> = (
  props,
) => {
  return (
    <fd-mfe-modal-dialog
      data-testid="order-confirmation-modal"
      prop:open={true}
      prop:dismissible={true}
      on:modal-dialog-close={() => props.onClose()}
    >
      <h2 slot="modal-dialog-header">Thank you for your order!</h2>
      <p slot="modal-dialog-body">
        Your Featured Dealer reservation request(s) have been placed.
      </p>
      <fd-mfe-modal-dialog-footer slot="modal-dialog-footer">
        <div class="flex justify-end w-full">
          <fd-mfe-button
            onClick={() => {
              publishFinalReviewDoneClick();
              props.onClose();
            }}
          >
            Done
          </fd-mfe-button>
        </div>
      </fd-mfe-modal-dialog-footer>
    </fd-mfe-modal-dialog>
  );
};
